import {
  hideTools,
  isPNIDDimmed,
  roomIdIsWet,
  SWI_PNID
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import {
  UDevGlobals,
  devicesOfGroup,
  getDeviceById,
  getDeviceByIdInclChanging,
  getDistinctGroupsOfDevs,
  getGroupById,
  getGroupOfDevice,
  getGroupsOfD,
  getGroupsOfDevice,
  getRoomById,
  inputsOfGroup,
  isRoomOutside,
  uDev
} from "src/components/Planner/planner/uDev";
import { chainChangeDevices } from "src/components/Planner/planner/uDev-dom";
import $ from "jquery";
import * as d3 from "d3";
import {
  _does,
  P_xytonum,
  uMath,
  vectorRotationDegree
} from "src/components/Planner/planner/uMath";
import {redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import {ts, ts2} from "src/utils/translate"
import {
  getAuthHeader,
  startLoading,
  stopLoading,
  toastError,
  toastInfo,
  toastInfoSingle,
  toastRemoveAll
} from "src/components/Planner/controller";
import {
  GroupPathFinder
} from "src/components/Planner/planner/groupPathFinderClass";
import {ROOT_URI} from "src/utils/constants"
import {redrawMeasurements} from "src/components/Planner/planner/measurement";
import {
  isCategoryShown
} from "src/components/Planner/planner/categoryDisplayHandler";

export let GroupingGlobals = {
  groupRecalcTimeouts: {},
  groupRecalcInProgress: {},
  groupRecalcAgainAfter: {},
}

export function getGroupHSVIndexes() {
  var groupsObj = {};

  var singles = [];
  var multis = [];
  var roomHSVs = {};

  PlannerGlobals.groups.forEach(function (group) {
    var groupObj = {
      hsvIdx: 0,
      rooms: []
    };

    group.deviceIds.forEach(function (id) {
      var device = getDeviceById(id);
      if (device /* && !device.input */) {
        var room = getRoomById(device.roomId);
        if (room && groupObj.rooms.indexOf(room.id) == -1) {
          groupObj.rooms.push(room.id);
        }
      }
    });

    if (groupObj.rooms.length == 1) {
      singles.push(groupObj);
    } else {
      multis.push(groupObj);
    }

    groupsObj[group.id] = groupObj;
  });

  singles.forEach(function (groupObj) {
    if (groupObj.rooms[0] in roomHSVs) {
      roomHSVs[groupObj.rooms[0]]++;
    } else {
      roomHSVs[groupObj.rooms[0]] = 0;
    }
    groupObj.hsvIdx = roomHSVs[groupObj.rooms[0]];
  });

  multis.forEach(function (groupObj) {
    var roomsHSVIdxes = [];
    groupObj.rooms.forEach(function (room) {
      if (room in roomHSVs) {
        roomsHSVIdxes.push(roomHSVs[room]);
      } else {
        roomsHSVIdxes.push(0);
      }
    });

    roomsHSVIdxes.sort(function (a, b) {
      return +a < +b;
    });
    var maxHSV = roomsHSVIdxes[0] + 1;
    groupObj.rooms.forEach(function (room) {
      roomHSVs[room] = maxHSV;
    });
    groupObj.hsvIdx = maxHSV;
  });

  return groupsObj;
}

export function redrawGroups(noMeasures = false, onlyGroupOfD = null) {
  PlannerGlobals.hsvIndexes = {};
  var groupHSVIndexes = getGroupHSVIndexes();

  /**
   * @type {Group[]}
   */
  var tarGroups;
  /**
   * @type {d3.Selection<any>}
   */
  var grouppaths;
  if (!onlyGroupOfD) {
    PlannerGlobals.svg.selectAll('#grouppaths').remove();
    grouppaths = PlannerGlobals.container.insert('g', '.devices').attr('class', 'grouppaths').attr('id', 'grouppaths');
    tarGroups = PlannerGlobals.groups;
  } else {
    grouppaths = d3.select("#grouppaths");
    tarGroups = getDistinctGroupsOfDevs(onlyGroupOfD.devices);
    tarGroups.forEach(function (group) {
      $('.line_group_' + group.id).remove();
    });
  }

  var lineFunction = d3.line()
    .curve(d3.curveBasis);

  tarGroups.forEach(function (group) {
    var grpDevs = group.deviceIds.map(getDeviceByIdInclChanging)
    .filter(function (dev) { return !!dev && !dev.changingFromOther; });

    if (grpDevs.length <= 1) { return; }

    grpDevs = grpDevs.filter(function (dev) {
      return isCategoryShown(dev.category_id);
    });
    grpDevs.forEach(function (dev) {
      dev.groupingProgress = false;
    });

    var devCenters = new GroupPathFinder().groupSalesman(grpDevs, PlannerGlobals.rooms).map(function (x) { return x.center; });
    var hsvVal = (groupHSVIndexes[group.id].hsvIdx * PlannerGlobals.HSV_INCREMENT) % 360;
    for (var i = 1; i < devCenters.length; i++) {
      var prevPt = devCenters[i - 1];
      var currPt = devCenters[i];
      var centerPt = uMath.pointsCenter(prevPt, currPt);

      var angle = vectorRotationDegree(prevPt, currPt) % 180 - 90;
      centerPt = uMath.pointAtAngleDistance(centerPt, angle, 10);

      var pts = [prevPt, centerPt, currPt].map(P_xytonum);

      let outputsPath = grouppaths.append('path')
        .attr('class', 'line_group_' + group.id)
        .attr('d', lineFunction(pts))
        .attr('stroke', 'black')
        .attr('stroke-width', 0.5)
        .attr('stroke-dasharray', '3 1')
        .attr('fill', 'none')
        .attr('style', "stroke: hsl(" + hsvVal + ", 90%, 58%);");
    }
  });

  if (!noMeasures) {
    redrawMeasurements();
  }
}

export function devicesGroupableWithoutSameName(dev1, dev2)
{
  const ids = [
    [197, 302]
  ];
  ids.forEach(function(value){
    if ((dev1.product_name_id == value[0] && dev2.product_name_id == value[1]) || (dev1.product_name_id == value[1] && dev2.product_name_id == value[0])) {
      return true;
    }
  });
  return false;
}

/**
 *
 * @param {Device} dev1
 * @param {Device} dev2
 */
export function areDevicesGroupable(dev1, dev2, silent = false) {
  var bothAreOutputs = !dev1.input && !dev2.input;
  /* var oneIsNotOutput = dev1.input && !dev2.input || !dev1.input && dev2.input; */
  var loxoneCompatible = dev1.is_loxone == dev2.is_loxone;
  /* var bothAreConventional = !dev1.is_loxone && !dev2.is_loxone; */
  var bothAreGroupable = dev1.groupable && dev2.groupable;
  var bothHaveSameName = dev1.product_name_id == dev2.product_name_id || (
      dev1.user_custom_item_id && dev2.user_custom_item_id && dev1.user_custom_item_id == dev2.user_custom_item_id
  ) || ((dev1.product_name_id == 197 && dev2.product_name_id == 302) || (dev1.product_name_id == 302 && dev2.product_name_id == 197));

  var sameDimmed = isPNIDDimmed(dev1.product_name_id) === isPNIDDimmed(dev2.product_name_id);

  var srcInGrp = !!getGroupOfDevice(dev1.deviceId);
  var tarInGrp = !!getGroupOfDevice(dev2.deviceId);
  var makingNewGrp = !srcInGrp && !tarInGrp;

  if (!bothAreGroupable) {
    return false;
  }
  if (!loxoneCompatible) {
    !silent && toastInfo(ts('p_not_loxone_compatible', "You can't pair Loxone products with non-Loxone ones."));
    return false;
  }
  else if (bothAreOutputs && !bothHaveSameName) {
    !silent && toastInfo(ts('p_not_same_outputs', "You can only pair the same type of outputs."));
    return false;
  }
  else if (makingNewGrp && dev1.input && dev2.input) {
    !silent && toastInfo(ts('p_no_two_inputs', "You can't start pairing with two inputs."));
    return false;
  }
  /* else if (!dev1.input && dev2.input) {
      toastInfo(ts('p_group_start_with_input', "Please drag the line from the input to the output first."));
  } */
  else if (!sameDimmed) {
    !silent && toastInfo(ts('p_dimmable_together', "You cannot group dimmed and switched products together."));
    return false;
  }

  return true;

}

export function areDevicesGroupableAllRules(srcDevId, tarDevId) {
  const srcDev = getDeviceById(srcDevId);
  const tarDev = getDeviceById(tarDevId);
  const devIdDifferent = srcDevId != tarDevId;

  if (!srcDev || !tarDev || !devIdDifferent) { return false; }

  const srcGrp = getGroupOfDevice(srcDevId);
  const tarGrp = getGroupOfDevice(tarDevId);

  const areDevicesGroupableOld = areDevicesGroupable(srcDev, tarDev, true);
  const conventionalError = checkConventionalGroupingRules(srcDev, tarDev, tarGrp, true);
  const isInputAdditionalConnection = pairIsCapableOfAdditionalConnection(srcDev, tarDev, srcGrp, tarGrp);

  const basicRules = (!srcGrp && !tarGrp || isInputAdditionalConnection) ||
      (srcGrp && !tarGrp) ||
      (!srcGrp && tarGrp) ||
      (srcGrp && tarGrp && srcGrp.id !== tarGrp.id);

  return basicRules && areDevicesGroupableOld && !conventionalError;
}

/**
 * Make a brand new group from two devices
 *
 * @param {any} devId1 ID of the first device
 * @param {any} devId2 ID of the second device
 */
export function makeNewGroup(devId1, devId2, callback, errorCallback, skipRulesCheck = false) {
  var dev1 = getDeviceById(devId1);
  var dev2 = getDeviceById(devId2);

  if (skipRulesCheck || areDevicesGroupable(dev1, dev2)) {
    dev1.groupingProgress = true;
    dev2.groupingProgress = true;
    hideTools();
    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/device/group-device-new',
        type: 'POST',
        dataType: 'JSON',
        data: {
          source_device_id: devId1,
          target_device_id: devId2
        },
        success: function (response) {
          PlannerGlobals.groups.push({
            id: response.new_group_id,
            deviceIds: [devId1, devId2]
          });
          redrawGroups();
          if (typeof callback == "function") {
            callback();
          }
        },
        error: function (response) {
          dev1.groupingProgress = false;
          dev2.groupingProgress = false;
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
          if (typeof errorCallback == "function") {
            errorCallback();
          }
        }
      });
    });
  } else {
    redrawGroups();
    if (typeof errorCallback == "function") {
      errorCallback();
    }
  }
}

export function makeNewGroupNoCheck(devId1, devId2, callback, errorCallback) {
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/device/group-device-new',
      type: 'POST',
      dataType: 'JSON',
      data: {
        source_device_id: devId1,
        target_device_id: devId2
      },
      success: function (response) {
        PlannerGlobals.groups.push({
          id: response.new_group_id,
          deviceIds: [devId1, devId2]
        });
        redrawGroups();
        if (typeof callback == "function") {
          callback();
        }
      },
      error: function (response) {
        if (response.responseJSON && response.responseJSON.message) {
          toastError(response.responseJSON.message);
        }
        if (typeof errorCallback == "function") {
          errorCallback();
        }
      }
    });
  });
}

export function addDevToGroupNoCheck(srcDevId, tarDevId, callback, errorCallback) {
  var group = getGroupOfDevice(tarDevId);
  var srcDev = getDeviceById(srcDevId);
  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      url: ROOT_URI + '/device/group-device-existing',
      type: 'POST',
      dataType: 'JSON',
      data: {
        source_device_id: srcDevId,
        target_device_id: tarDevId
      },
      success: function (response) {
        var grpNewRef = getGroupById(group.id)
        if (grpNewRef) {
          grpNewRef.deviceIds.push(srcDevId);
        }
        if (!UDevGlobals.devIsChangingToObj[srcDev.deviceId] && !srcDev.changingFromOther) {
          redrawGroups();
        }
        if (typeof callback == "function") {
          callback();
        }
      },
      error: function (response) {
        if (response.responseJSON && response.responseJSON.message) {
          toastError(response.responseJSON.message);
        }
        if (typeof errorCallback == "function") {
          errorCallback();
        }
      }
    });
  });
}

/**
 *
 * @param {Device} device
 */
export function devRoomBasicSwiPNID(device) {
  if (!device) { return SWI_PNID.onepole_101; }
  var deviceRoom = getRoomById(device.roomId);
  if (!deviceRoom) { return SWI_PNID.onepole_101; }

  var roomIsWet = deviceRoom.room_type_id == 7 || deviceRoom.room_type_id == 8;
  var roomIsOutside = uDev.outerBorderExists() && isRoomOutside(deviceRoom, PlannerGlobals.outerBorder);

  return (roomIsWet || roomIsOutside) ? SWI_PNID.twopole_102 : SWI_PNID.onepole_101;
}


export function isGroupAnyItemWet(groupId) {
  groupId = +groupId;
  var groupDevs = devicesOfGroup(groupId);
  if (!groupDevs) { return null; }
  return groupDevs.some(function (dev) { return roomIdIsWet(dev.roomId); });
}

export function isGroupOutputWet(groupId) {
  groupId = +groupId;
  var groupDevs = devicesOfGroup(groupId);
  if (!groupDevs) { return null; }
  return groupDevs.some(function (dev) { return !dev.input && roomIdIsWet(dev.roomId); });
}

export function groupBasicSwiPNID(groupId) {
  groupId = +groupId;
  var pnid = SWI_PNID.onepole_101;
  var inputs = inputsOfGroup(groupId);
  var groupAnyWet = isGroupAnyItemWet(groupId);
  if (groupAnyWet && inputs.length === 1) {
    pnid = SWI_PNID.twopole_102;
  }
  else if (Array.isArray(inputs) && inputs.length > 1) {
    pnid = SWI_PNID.switch_106;
  }

  return pnid;
}

export function isGroupAutoCalcPrevented(groupId) {
  groupId = +groupId;
  var groupDevs = devicesOfGroup(groupId);
  if (!groupDevs) { return null; }
  var groupInputs = groupDevs.filter(function (dev) { return dev.input; });

  var everyInputIsLightSwitch = groupInputs.every(function (dev) { return isDevLightingSwitch(dev); });
  if (!everyInputIsLightSwitch) { return true; }

  return false;
}

/**
 *
 * @param {Group[]} groups
 */
export function showGroupInvalidMsgIfAnyIsInvalid(groups) {
  var invalidGroupMsg = groups
  .map(function (grp) { return isGroupAutoCalcPrevented(grp.id); })
  .find(function (x) { return !!x; });

  if (invalidGroupMsg && typeof invalidGroupMsg === "string") {
    toastInfoSingle(invalidGroupMsg);
  }
  else {
    toastRemoveAll();
  }
}

/**
 *
 * @param {Device} device
 */
export function isDevBasicSwitch(device) {
  if (!device) { return false; }
  return uMath._does([
    SWI_PNID.onepole_101,
    SWI_PNID.twopole_102,
    SWI_PNID.switch_106,
  ]).contain(device.product_name_id);
}

/**
 * Returns the number of lighting circuits controller by the switch
 * @param {Device} switchDevice
 * @returns {Group[]}
 */
export function circuitsControlledBySwitch(switchDevice) {
  return getGroupsOfDevice(switchDevice.deviceId) // get all groups of switch
  .filter(function (grp) { // filter groups by ...
    return grp.deviceIds.map(getDeviceById)
    .filter(function (dev) { return !dev.input; }).length > 0; // return true if group has at least 1 output (lighting)
  });
}

/**
 *
 * @param {Device} switchDevice
 * @returns {number}
 */
export function maxCircuitsForSwitch(switchDevice) {
  var maxCircuits = {
    [SWI_PNID.dimmer]: 1,
    [SWI_PNID.onepole_101]: 2,
    [SWI_PNID.twopole_102]: 2, // should be 1, but we can connect 2 to it, and it will be auto converted
    [SWI_PNID.chandelier_105]: 2,
    [SWI_PNID.cross_107]: 2,
    [SWI_PNID.double_106p6]: 2,
    [SWI_PNID.switch_106]: 2,

  }
  if (switchDevice.product_name_id in maxCircuits) {
    return maxCircuits[switchDevice.product_name_id];
  }
  else {
    return 1;
  }
}

/**
 * Returns the index of the input in a group. Indexing starts from 0. Only takes inputs into account
 * @param {Device} switchDevice
 * @param {Group} group
 * @returns {number}
 */
export function inputIsNthInGroup(switchDevice, group) {
  return group.deviceIds.map(getDeviceById)
  .filter(function (dev) { return dev.input; })
  .findIndex(function (dev) { return dev.deviceId === switchDevice.deviceId; });
}

/**
 * Returns how many switches are in the group
 * @param {Group} group
 * @returns {number}
 */
export function groupIsControlledByNSwitches(group) {
  return group.deviceIds.map(getDeviceById).filter(function (dev) { return dev.input; }).length;
}

export let recalcSwitchTimeout = null;
export let recalcSwitchInProgress = false;
export let recalcSwitchAfter = false;

export function isDevLightingSwitch(dev) {
  if (typeof dev !== "object") { return false; }
  var pnid = -1;
  if (typeof dev.id === "string") {
    pnid = +dev.id.replace('product_', '');
  }
  else {
    pnid = +dev.product_name_id;
  }

  return _does(Object.values(SWI_PNID)).contain(pnid);
}

/**
 *
 * recalcgroupswitches
 * @param {function} callback
 */
export function recalcSwitchPNIDs(callback) {
  // if another instance is in progress, finish that first, and rerun after that
  if (recalcSwitchInProgress) {
    recalcSwitchAfter = true;
    return;
  }

  // if dragging something that is in a group, only calc after letting go of the dragged dev
  if (PlannerGlobals.DRAG_HELPER.draggedD3Dev) {
    var draggedGrps = getGroupsOfD(PlannerGlobals.DRAG_HELPER.draggedD3Dev);
    if (draggedGrps.length) {
      recalcSwitchAfter = true;
      return;
    }
  }

  if (recalcSwitchTimeout) { clearTimeout(recalcSwitchTimeout); }

  recalcSwitchTimeout = setTimeout(function () {
    recalcSwitchInProgress = true;
    startLoading();
    /**
     * @type {{srcDevice: Device, targetProductId: number}[]}
     */
    var changeParams = [];
    var switchesInGroups = PlannerGlobals.devices
    .filter(function (dev) {
      return dev.input && isDevLightingSwitch(dev) && circuitsControlledBySwitch(dev).length > 0;
    })
    .map(function (dev) {
      return getDeviceByIdInclChanging(dev.deviceId);
    });

    /**
     * @type {Object.<number, Device[]>}
     */
    var groupSingleSwitches = {};
    /**
     * @type {Object.<number, Device[]>}
     */
    var groupDoubleSwitches = {};

    switchesInGroups.forEach(function (switchDev) {
      var switchGroups = getGroupsOfDevice(switchDev.deviceId);
      if (switchGroups.length === 1) {
        var switchGroup = switchGroups[0];
        if (isGroupAutoCalcPrevented(switchGroup.id)) {
          //console.log('skipping invalid group');
          return;
        }
        var switchIdx = inputIsNthInGroup(switchDev, switchGroups[0]);
        if (isPNIDDimmed(switchDev.product_name_id)) {
          if (switchIdx === 0) {
            changeParams.push({ srcDevice: switchDev, targetProductId: SWI_PNID.dimmer });
          }
          else {
            changeParams.push({ srcDevice: switchDev, targetProductId: SWI_PNID.dimmer }); // TODO change to 1 pushbutton
          }
        }
        else {
          if (!(switchGroup.id in groupSingleSwitches)) { groupSingleSwitches[switchGroup.id] = []; }
          groupSingleSwitches[switchGroup.id].push(switchDev);
        }
      }
      else if (switchGroups.length === 2) {
        if (switchGroups.some(function (grp) { return isGroupAutoCalcPrevented(grp.id); })) {
          console.log('skipping invalid groups');
          return;
        }
        switchGroups.forEach(function (grp) {
          if (!(grp.id in groupDoubleSwitches)) { groupDoubleSwitches[grp.id] = []; }
          groupDoubleSwitches[grp.id].push(switchDev);
        });
        var anyGroupIsSwitchedByOther = switchGroups.some(function (grp) {
          return groupIsControlledByNSwitches(grp) > 1;
        });
        if (anyGroupIsSwitchedByOther) {
          changeParams.push({ srcDevice: switchDev, targetProductId: SWI_PNID.double_106p6 });
        }
        else {
          changeParams.push({ srcDevice: switchDev, targetProductId: SWI_PNID.chandelier_105 });
        }
      }
    });

    for (var groupId in groupSingleSwitches) {
      if (isGroupAutoCalcPrevented(groupId)) {
        console.log('skipping invalid group');
        continue;
      }
      var basicSwitchPNID = groupBasicSwiPNID(groupId);

      var switches = groupSingleSwitches[groupId];
      var doubleSwitches = groupDoubleSwitches[groupId] || [];

      var basicSwitches = switches.filter(function (dev) { return dev.product_name_id == basicSwitchPNID; });
      var otherSwitches = switches.filter(function (dev) { return dev.product_name_id != basicSwitchPNID; });

      var neededBasicSwitches = 0;
      if (basicSwitches.length < 2 - doubleSwitches.length) {
        var neededBasicSwitches = Math.max(2 - doubleSwitches.length - basicSwitches.length, 0);

        otherSwitches.slice(0, neededBasicSwitches).forEach(function (dev) {
          changeParams.push({ srcDevice: dev, targetProductId: basicSwitchPNID });
        });
      }
      else if (basicSwitches.length > 2 - doubleSwitches.length) {
        otherSwitches = otherSwitches.concat(basicSwitches.slice(2 - doubleSwitches.length, basicSwitches.length));
      }

      basicSwitches.forEach(function (dev) {
        changeParams.push({ srcDevice: dev, targetProductId: basicSwitchPNID });
      });

      otherSwitches.slice(neededBasicSwitches, otherSwitches.length).forEach(function (dev) {
        changeParams.push({ srcDevice: dev, targetProductId: SWI_PNID.cross_107 });
      });
    }

    changeParams = changeParams
    .filter(function (changeParam) {
      return +changeParam.srcDevice.product_name_id !== +changeParam.targetProductId;
    })
    .map(function (changeParam) {
      return {
        srcDeviceId: changeParam.srcDevice.deviceId,
        targetProductId: changeParam.targetProductId
      }
    });

    chainChangeDevices(changeParams, 0, function (res) {
      recalcSwitchInProgress = false;
      if (changeParams.length > 0) {
        redrawDevices();
      }
      stopLoading();
      if (recalcSwitchAfter) {
        recalcSwitchAfter = false;
        recalcSwitchPNIDs(callback);
      }
      else if (typeof callback === "function") {
        callback(res);
      }
    });
  }, 50);
}

/**
 * Add a device to an already made group
 *
 * @param {any} devId ID of the device to be added
 * @param {any} group Reference of the target group
 */
export function addDevToGroup(devId, group, callback, errorCallback, skipRulesCheck = false) {
  var srcDev = getDeviceById(devId);
  var tarDev;
  for (var i = 0; i < group.deviceIds.length; i++) {
    var dev = getDeviceById(group.deviceIds[i]);
    if (skipRulesCheck || !dev.input) {
      tarDev = dev;
      break;
    }
  }
  if (!tarDev) {
    toastInfo(ts('p_group_start_with_input', "Please drag the line from the input to the output first."));
    if (typeof errorCallback == "function") {
      errorCallback();
    }
    return;
  }

  var canJoin = areDevicesGroupable(srcDev, tarDev);

  if (canJoin) {
    srcDev.groupingProgress = true;
    hideTools();
    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: ROOT_URI + '/device/group-device-existing',
        type: 'POST',
        dataType: 'JSON',
        data: {
          source_device_id: devId,
          target_device_id: tarDev.deviceId
        },
        success: function (response) {
          var grpNewRef = getGroupById(group.id)
          if (grpNewRef) {
            grpNewRef.deviceIds.push(devId);
          }
          srcDev.groupingProgress = false;
          if (!UDevGlobals.devIsChangingToObj[srcDev.deviceId] && !srcDev.changingFromOther) {
            redrawGroups();
          }
          if (typeof callback == "function") {
            callback();
          }
        },
        error: function (response) {
          if (response.responseJSON && response.responseJSON.message) {
            toastError(response.responseJSON.message);
          }
          if (typeof errorCallback == "function") {
            errorCallback();
          }
        }
      });
    });
  }
  else if (typeof errorCallback == "function") {
    errorCallback();
  }
}
/**
 * Merge two groups - [This behavior isn't supported as of now]
 *
 * @param {any} sourceGroup
 * @param {any} targetGroup
 */
export function mergeGroups(sourceGroup, targetGroup) {
  //do nothing
}

/**
 *
 * @param {Group} group
 */
export function groupIsControlledByTwoPole(group) {
  if (!group) { return false; }
  if (groupIsControlledByNSwitches(group) === 1) {
    var grpSwitch = group.deviceIds.map(getDeviceById).find(function (dev) { return dev.input; });
    return grpSwitch && grpSwitch.product_name_id == SWI_PNID.twopole_102;
  }
  return false;
}


/**
 *
 * @param {Group} group
 * @param {number} categoryId
 */
export function areGroupInputsFromCategory(group, categoryId) {
  if (!group) { return false; }
  var groupDevs = devicesOfGroup(group.id);
  if (!groupDevs) { return false; }
  var groupInputs = groupDevs.filter(function (dev) { return dev.input; });
  return groupInputs.every(function (dev) { return dev.category_id === categoryId; });
}

/**
 * Returns true if the group has at least two "Double 2-way" switches
 * @param {Group} group
 */
export function groupHasTwoDoubleTwoWays(group) {
  if (!group) { return false; }
  var groupDevs = devicesOfGroup(group.id);
  if (!groupDevs) { return false; }
  return groupDevs.filter(function (dev) { return dev.product_name_id == SWI_PNID.double_106p6; }).length >= 2;
}

export function isDevShadingType(dev) {
  if (typeof dev !== "object") { return false; }
  var categId, pnid;
  if (typeof dev.parent === "string" && typeof dev.id === "string") {
    categId = +dev.parent.replace('category_', '');
    pnid = +dev.id.replace('product_', '');
  }
  else {
    categId = +dev.category_id;
    pnid = +dev.product_name_id;
  }
  return categId == 18 || pnid == 322 || pnid == 323;
}

/**
 *
 * @param {Device} srcDev
 * @param {Device} tarDev
 * @param {Group} targetGroup
 */
export function checkConventionalGroupingRules(srcDev, tarDev, targetGroup, silent = false) {
  if (pnidIsAtGroupLimit(srcDev.product_name_id, targetGroup)) {
    !silent && toastInfoSingle(ts2('p_grp_limit', 'A group can only include {max_num} devices.', { max_num: PNID_GROUP_LIMIT[srcDev.product_name_id] }));
    return true;
  }


  if (isDevShadingType(srcDev) || isDevShadingType(tarDev)) {
    if (!isDevShadingType(srcDev) || !isDevShadingType(tarDev)) {
      !silent && toastInfoSingle(ts('p_shading_diff_categ', 'Shading products can only be grouped with each other.'));
      return true;
    }
    if (targetGroup) {
      if (srcDev.input) {
        !silent && toastInfoSingle(ts('p_shading_more_inputs_err', 'A switched shading actuator can only be controlled by one shading switch.'));
      }
      else {
        !silent && toastInfoSingle(ts('p_shading_more_outputs_err', 'A shading switch can only control one switched shading actuator.'));
      }
      return true;
    }
  }
  else if (!srcDev.is_loxone && !tarDev.is_loxone) {
    if (!srcDev.input && tarDev.input && maxCircuitsForSwitch(tarDev) <= circuitsControlledBySwitch(tarDev).length) {
      !silent && toastInfoSingle(ts('p_switch_max_capacity', "This switch can't handle more circuits. If you want to connect an output to an existing circuit, connect this device to an output."));
      return true;
    }

    if (srcDev.input && tarDev.input && circuitsControlledBySwitch(tarDev).length > 1) {
      !silent && toastInfoSingle(ts('p_switch_ambi', 'Ambiguous selection. Please group the input with a device that has no more than one group.'));
      return true;
    }

    if (!srcDev.input && tarDev.input && getGroupsOfDevice(tarDev.deviceId).length === 1 && groupHasTwoDoubleTwoWays(targetGroup)) {
      !silent && toastInfoSingle(ts('p_toomuch_2way', 'To create this grouping, the target switch would be changed to a Double 2-way switch, but we can only have two of those in a circuit.'));
      return true;
    }

    if (srcDev.input && targetGroup && !areGroupInputsFromCategory(targetGroup, srcDev.category_id)) {
      !silent && toastInfoSingle(ts('p_switch_categ_mix', 'You cannot have inputs from different categories in a circuit.'));
      return true;
    }
  }
  return false;
}

export let PNID_GROUP_LIMIT = {
  102: 6, // LED Strip WW - fake pnid
  208: 6, // LED Strip RGB - fake pnid
  659: 4, // LED Pendulum Slim PWM - White
  660: 4, // LED Pendulum Slim PWM - Anthracite
  661: 6, // LED Ceiling Spot WW PWM - White
  662: 6, // LED Ceiling Spot WW PWM - Anthracite
  471: 5, // 24V RGBW controlled downlight
  728: 6, // 24V PWM Controlled Downlight
  729: 5, // 24V Dualtone Downlight
  894: 5, // Generic 24V Dual white led stripe
}

/**
 *
 * @param {number} pnid
 * @param {Group} group
 */
export function numberOfPNIDInGroup(pnid, group) {
  return !!group && group.deviceIds.map(devId => getDeviceById(devId)).filter(dev => dev.product_name_id == pnid).length;
}

export function pnidIsAtGroupLimit(pnid, group) {
  return !!group && (pnid in PNID_GROUP_LIMIT) && numberOfPNIDInGroup(pnid, group) >= PNID_GROUP_LIMIT[pnid];
}

export function pairIsCapableOfAdditionalConnection(srcDev, tarDev, sourceGroup, targetGroup) {
  var oneIsInput = srcDev.input || tarDev.input;
  var bothAreInputs = srcDev.input && tarDev.input;
  var oneIsOutputAndInGroup = !srcDev.input && sourceGroup || !tarDev.input && targetGroup;
  var inputDev = oneIsInput ? (srcDev.input ? srcDev : tarDev) : null;
  var switchCurrCircuits = inputDev ? circuitsControlledBySwitch(inputDev).length : 0;
  var switchMaxCircuits = inputDev ? maxCircuitsForSwitch(inputDev) : 0;

  return oneIsInput && !bothAreInputs && !oneIsOutputAndInGroup && switchCurrCircuits < switchMaxCircuits;
}

/**
 * The event handler that runs when the mouse or a finger is released over a device while grouping
 *
 * @param {any} sourceDevId
 * @param {any} targetDeviceId
 * @returns
 */
export function mouseupGroup(sourceDevId, targetDeviceId, callback, errorCallback, skipRulesCheck = false) {
  //if target and source are the same
  if (sourceDevId == targetDeviceId) {
    console.log('tried to group dev w/ itself')
    if (typeof callback == "function") {
      callback();
    }
    return;
  }

  var srcDev = getDeviceById(sourceDevId);
  var tarDev = getDeviceById(targetDeviceId);

  if (!srcDev || !tarDev || srcDev.ghost || tarDev.ghost) {
    console.log('tried to group ghost dev')
    if (typeof callback == "function") {
      callback();
    }
    return;
  }

  var sourceGroup = getGroupOfDevice(sourceDevId);
  var targetGroup = getGroupOfDevice(targetDeviceId);

  // conditions to check if both are conventional
  var conventionalError = checkConventionalGroupingRules(srcDev, tarDev, targetGroup);

  if (conventionalError) {
    if (typeof callback == "function") {
      callback();
    }
    return;
  }
  else {
    toastRemoveAll();
  }

  var isInputAdditionalConnection = pairIsCapableOfAdditionalConnection(srcDev, tarDev, sourceGroup, targetGroup);

  //if neither of them are in a group
  if (!sourceGroup && !targetGroup || isInputAdditionalConnection) {
    //make a new group, add both of them to it
    makeNewGroup(sourceDevId, targetDeviceId, callback, errorCallback, skipRulesCheck);
  }
  //if source is in a group but target is not
  else if (sourceGroup && !targetGroup) {
    //add target to source's group
    addDevToGroup(targetDeviceId, sourceGroup, callback, errorCallback, skipRulesCheck);
  }
  //if target is in a group but source is not
  else if (!sourceGroup && targetGroup) {
    //add source to target's group
    addDevToGroup(sourceDevId, targetGroup, callback, errorCallback, skipRulesCheck);
  }
  //if both of them are in groups
  else if (sourceGroup && targetGroup && sourceGroup.id !== targetGroup.id) {
    /* console.log('merge') */
    addDevToGroup(sourceDevId, targetGroup, callback, errorCallback, skipRulesCheck)
  }
  else {
    if (typeof callback === "function") {
      callback();
    }
  }
}
